import { Component, output } from '@angular/core';
import { ZiroTextComponent } from '../../../forms/fields/text/ziro-text.component';
import { ZiroFieldAbstractDirective } from '../../../forms/ziro-field-abstract.directive';

export enum PinResetOptions {
  VOICEMAIL = 'voicemailPinReset',
  END_USER = 'extensionMobPinReset',
}

@Component({
  selector: 'ziro-pin-reset',
  templateUrl: './pin-reset.component.html',
  providers: [{ provide: ZiroFieldAbstractDirective, useExisting: PinResetComponent }],
  standalone: false,
})
export class PinResetComponent extends ZiroTextComponent {
  readonly resetClicked = output<string>();
  isPending = false;

  submit(id: string): void {
    this.isPending = true;
    this.resetClicked.emit(id);
  }
}
